function timeConversion(millisec) {
    if (millisec === 0) return 0
    var seconds = (millisec / 1000).toFixed(0)

    var minutes = (millisec / (1000 * 60)).toFixed(0)

    var hours = (millisec / (1000 * 60 * 60)).toFixed(0)

    var days = (millisec / (1000 * 60 * 60 * 24)).toFixed(0)

    if (seconds < 60) {
        return seconds + 's'
    } else if (minutes < 60) {
        return minutes + 'm'
    } else if (hours < 24) {
        return hours + 'h'
    } else {
        return days + 'd'
    }
}

export default timeConversion



// WEBPACK FOOTER //
// ./src/modules/msToReadable.js